import { T } from 'gt-react';
import {
  CheckCircleIcon,
  FilePdfIcon,
  UserSwitchIcon,
} from '@phosphor-icons/react';
import type { ArTaskRow } from '@erp/rpc';
import type { ColumnDef, Table } from '@/lib/tanstack-table';
import { BulkActionsBar } from '@/components/common/data-table/bulk-actions-bar';
import { Button } from '@/components/ui/button';
import { useArTasksPdfDownload } from './useArTasksPdfDownload';

/**
 * Bulk bar for selected AR tasks: Assign, Close Task, Download PDF. Assign
 * and Close change the task itself, so they need Task update permission;
 * the PDF only reads. The page offers no Send: Famous decides when an
 * invoice is sent.
 */
export function ArTasksBulkActions({
  selectedCount,
  canManageTasks,
  table,
  columns,
  selectedRows,
  onClear,
  onAssign,
  onClose,
}: {
  selectedCount: number;
  canManageTasks: boolean;
  /** The table, columns and selection the PDF mirrors. */
  table: Table<ArTaskRow>;
  columns: ColumnDef<ArTaskRow>[];
  selectedRows: ArTaskRow[];
  onClear: () => void;
  onAssign: () => void;
  onClose: () => void;
}) {
  const { downloadPdf, pdfDisabled } = useArTasksPdfDownload({
    table,
    columns,
    selectedRows,
  });
  return (
    <BulkActionsBar selectedCount={selectedCount} onClear={onClear}>
      {canManageTasks && (
        <>
          <Button size="sm" variant="outline" onClick={onAssign}>
            <UserSwitchIcon className="mr-1 size-4" />
            <T context="AR tasks bulk action, assign selected tasks">Assign</T>
          </Button>
          <Button size="sm" variant="outline" onClick={onClose}>
            <CheckCircleIcon className="mr-1 size-4" />
            <T context="AR tasks bulk action, close selected tasks">
              Close Task
            </T>
          </Button>
        </>
      )}
      <Button
        size="sm"
        variant="outline"
        onClick={() => void downloadPdf()}
        disabled={pdfDisabled}
      >
        <FilePdfIcon className="mr-1 size-4" />
        <T context="AR tasks bulk action, download selected tasks as PDF">
          Download PDF
        </T>
      </Button>
    </BulkActionsBar>
  );
}
